import { createContext, useState } from "react";
import { IUserState, UserAttrNameState, userInitialState} from "./states/userState";

export const userContext = createContext({} as userContextProps);

export interface userContextProps {
    getDataByAttributeName: (attr: UserAttrNameState) => any;
    setDataByAttributeName: (attr: UserAttrNameState, data: any) => void;
    
    getDataAll: () => IUserState;
    setDataAll: (data: IUserState) => void;  
}

export const UserContextProvider = (props: any) => {

    const [userData, setUserData] = useState<IUserState>({...userInitialState});

    const getDataByAttributeName = (attrName: UserAttrNameState) => {
        return userData[attrName];
    }

    const getDataAll = () => {
        return userData;
    }

    const setDataByAttributeName = (attrName: UserAttrNameState, data: any) => {
        setUserData((prevUserData) => ({
            ...prevUserData, [attrName]: data
        }));
    }

    const setDataAll = (data: IUserState) => {
        setUserData(data);
    }

    return(
        <userContext.Provider value={{
            getDataByAttributeName,
            getDataAll,
            setDataByAttributeName,
            setDataAll,
        }}>
            {props.children}
        </userContext.Provider>
    )
}